export default __webpack_public_path__ + "static/media/spaces-footer-cta.baccff7e.jpg";